'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _homeSlide = require('./home-slide-1.jpg');

var _homeSlide2 = _interopRequireDefault(_homeSlide);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Intro = function (_Component) {
  (0, _inherits3.default)(Intro, _Component);

  function Intro() {
    (0, _classCallCheck3.default)(this, Intro);
    return (0, _possibleConstructorReturn3.default)(this, (Intro.__proto__ || (0, _getPrototypeOf2.default)(Intro)).apply(this, arguments));
  }

  (0, _createClass3.default)(Intro, [{
    key: 'render',
    value: function render() {
      var styles = require('./Intro.scss');
      return _react2.default.createElement(
        'div',
        { className: styles.intro },
        _react2.default.createElement(
          'div',
          { className: styles.title },
          'Gi\u1EDBi thi\u1EC7u Lookme'
        ),
        _react2.default.createElement(
          'div',
          { className: styles.introSection },
          _react2.default.createElement(
            'p',
            null,
            'Ch\xE0o m\u1EEBng c\xE1c b\u1EA1n \u0111\u1EBFn v\u1EDBi Lookme \u2013 c\u1ED9ng \u0111\u1ED3ng d\xE0nh cho t\u1EA5t c\u1EA3 nh\u1EEFng ai Y\xCAU C\xC1I \u0110\u1EB8P v\xE0 TH\xCDCH L\xC0M \u0110\u1EB8P!'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Lookme ra \u0111\u1EDDi v\u1EDBi m\u1EE5c \u0111\xEDch chia s\u1EBB nh\u1EEFng \u0111\u1ECBa \u0111i\u1EC3m l\xE0m \u0111\u1EB9p uy t\xEDn, ch\u1EA5t l\u01B0\u1EE3ng, ph\xF9 h\u1EE3p v\u1EDBi nhu c\u1EA7u v\xE0 t\xFAi ti\u1EC1n c\u1EE7a m\u1ECDi ng\u01B0\u1EDDi tr\xEAn kh\u1EAFp m\u1ECDi mi\u1EC1n \u0111\u1EA5t n\u01B0\u1EDBc.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Kh\xF4ng ch\u1EC9 cung c\u1EA5p to\xE0n b\u1ED9 th\xF4ng tin v\u1EC1 c\xE1c \u0111\u1ECBa \u0111i\u1EC3m v\xE0 nh\u1EEFng \u0111\xE1nh gi\xE1 t\u1EEB nh\u1EEFng ng\u01B0\u1EDDi \u0111\xE3 tr\u1EA3i nghi\u1EC7m, Lookme c\xF2n gi\xFAp b\u1EA1n chia s\u1EBB h\xECnh \u1EA3nh, \u0111\u01B0a ra nh\u1EADn x\xE9t v\xE0 t\u1EA1o nh\u1EEFng \u0111\u1ECBa \u0111i\u1EC3m y\xEAu th\xEDch cho ri\xEAng m\xECnh. Th\xF4ng qua Lookme, b\u1EA1n c\u0169ng c\xF3 th\u1EC3 k\u1EBFt n\u1ED1i v\u1EDBi b\u1EA1n b\xE8 ho\u1EB7c ng\u01B0\u1EDDi qu\u1EA3n l\xFD c\u1EE7a \u0111\u1ECBa \u0111i\u1EC3m b\u1EA1n t\xECm ki\u1EBFm m\u1ED9t c\xE1ch nhanh ch\xF3ng.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Lookme.vn \u1EE9ng d\u1EE5ng c\xF4ng ngh\u1EC7 \u0111\u1EC3 \u0111\u01B0a nh\u1EEFng b\xECnh lu\u1EADn tin c\u1EADy, gi\u1EDBi thi\u1EC7u nh\u1EEFng \u0111\u1ECBa \u0111i\u1EC3m l\xE0m \u0111\u1EB9p \u0111\u01B0\u1EE3c y\xEAu th\xEDch \u0111\u1EBFn v\u1EDBi c\u1ED9ng \u0111\u1ED3ng.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'R\u1EA5t d\u1EC5 d\xE0ng cho b\u1EA1n tra c\u1EE9u th\xF4ng tin tr\xEAn hai phi\xEAn b\u1EA3n: desktop v\xE0 \u0111i \u0111\u1ED9ng. S\u1EAFp t\u1EDBi, b\u1EA1n c\xF2n c\xF3 c\u01A1 h\u1ED9i tr\u1EA3i nghi\u1EC7m \u1EE9ng d\u1EE5ng Lookme tr\xEAn Android v\xE0 IOS.'
          ),
          _react2.default.createElement(
            'p',
            null,
            '\u0110\u1EB8P L\xC0 S\u1EBA CHIA \u2013 CHIA S\u1EBA L\xC0 \u0110\u1EB8P! H\xE3y \u0111\u1ED3ng h\xE0nh c\xF9ng Lookme ngay h\xF4m nay n\xE0o!'
          ),
          _react2.default.createElement('img', { src: _homeSlide2.default, alt: 'lookme.vn' })
        )
      );
    }
  }]);
  return Intro;
}(_react.Component);

exports.default = Intro;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Policy/Intro.js
// module id = 1652
// module chunks = 0